import { z } from 'zod';
import type {
  VoidCoverShipmentRequest,
  VoidCoverShipmentResponse,
} from './void-cover-shipment.dto.js';
import { CoverShipmentDetailSchema } from './cover-shipments-shared.schema.js';

export const VoidCoverShipmentRequestSchema: z.ZodType<VoidCoverShipmentRequest> = z
  .object({
    companyId: z.uuid(),
    coverShipmentId: z.uuid(),
    reason: z.string().trim().min(1),
  })
  .strict();

export const VoidCoverShipmentResponseSchema: z.ZodType<VoidCoverShipmentResponse> = z
  .object({
    coverShipment: CoverShipmentDetailSchema,
  })
  .strict();
